import { getNodeEntries, getRange, removeMark, createPluginFactory } from '@udecode/plate-common';

export const MARK_FAKE_SELECTION = 'fakeSelection';

export const createFakeSelectionPlugin = createPluginFactory({
  key: MARK_FAKE_SELECTION,
  isLeaf: true,
  inject: {
    props: {
      nodeKey: MARK_FAKE_SELECTION,
      defaultNodeValue: '#eeeeee',
      styleKey: 'backgroundColor',
    },
  },
});

export const removeFakeSelection = (editor) => {
  // We get all nodes in the editor because we absolutely want to remove this mark at all costs.
  const nodes = getNodeEntries(editor, { at: [] }) ?? {};
  if (nodes) {
    // eslint-disable-next-line no-restricted-syntax
    for (const nodeEntry of nodes) {
      const [node, path] = nodeEntry;

      if (node.fakeSelection) {
        // removeMark needs a range to correctly remove marks when using at prop.
        const range = getRange(editor, path);
        removeMark(editor, { key: 'fakeSelection', at: range });
      }
    }
  }
};
